import RTGoogleAnalyticsManager from 'common/RTGoogleAnalyticsManager';
import Story from './Story';

export const reportPricingTableOpened = (source='unknown') => {
  RTGoogleAnalyticsManager.sendEvent('pricing_table', 'open', source, undefined, false);
  Story.pricingTableOpened(source)
}

export const reportRetakePretestUsed = (source='unknown') => {
    RTGoogleAnalyticsManager.sendEvent('retake_pretest', 'used', source, undefined, false);
    Story.addStep('retake_pretest', {
        param1: 'used',
        param2: source,
    });
}

export const reportActivitySubmitted = (source='unknown') => {
    RTGoogleAnalyticsManager.sendEvent('activity', 'submitted', source, undefined, false);
    Story.addStep('activity', {
        param1: 'submitted',
        param2: source,
    });
}


